export const MY_PROFILE_LOGIN_INFORMATION_USERNAME =
  "my-profile-login-information-username";
export const MY_PROFILE_LOGIN_INFORMATION_USERNAME_VALUE =
  "my-profile-login-information-username-value";
export const MY_PROFILE_LOGIN_INFORMATION_PASSWORD =
  "my-profile-login-information-password";
export const MY_PROFILE_LOGIN_INFORMATION_PASSWORD_VALUE =
  "my-profile-login-information-password-value";
export const MY_PROFILE_LOGIN_INFORMATION_RESET_PASSWORD_LINK =
  "my-profile-login-information-reset-password-link";
export const MY_PROFILE_LOGIN_INFORMATION_RESET_PASSWORD_LABEL =
  "my-profile-reset-password-label";
